import DeviceDetector from "device-detector-js";

export const getGPSInfo = (): Promise<Position> => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    } else {
      reject();
    }
  });
};

export interface DeviceInfo {
  os?: string;
  version?: string;
  brand?: string;
  device?: string;
}

export const getDeviceInfo = (userAgent: string): DeviceInfo => {
  const deviceDetector = new DeviceDetector();
  const device = deviceDetector.parse(userAgent);
  return {
    os: device.os?.name,
    version: device.os?.version,
    brand: device.device?.brand,
    device: device.device?.model
  };
};
